module.exports = "/_next/static/images/italian-9c6714b60836ce0369ba64ccfb4d2356.png";